import React, { useState } from 'react';
import renderHTML from 'react-render-html';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { Button } from 'telstra-ui/components/button/Button';
import Modal from 'telstra-ui/components/modal/Modal';
import Pagination from 'telstra-ui/components/pagination/Pagination';
import { ToolTip } from 'telstra-ui/components/tool-tip/Tooltip';
import { TextInput } from 'telstra-ui/components/text-input/TextInput';
import { prepareDropDownOptionsArry } from '../../amp-homepage.actions';
import { formatPhoneNumber } from '../../../ffwd-homepage/ffwd-homepage.actions';
import AddOnFilters from '../add-on-filters/add-on-filters';
import './add-on-table.css';

const AddOnTable = (props) => {
  const {
    authorableContent,
    authorableContent: {
      formFields: {
        iDOCallingPlans,
        dataTopUpPlans,
        addOnSearchFields,
      },
      username,
      itemSelectedText,
      intCallingIDO,
      voice2Text,
      messageBankIphone,
      oneNumber,
      iRMonthPass,
      accelerator,
      demandData,
      dataTopUp,
      serviceType,
      paginationNumbers,
      paginationBaseNumber,
      acceleratorToolTip,
      filterClearAll,
      filterEditTopLink,
      filterTopLink,
      bulkActionText,
      addOnNA,
      planTypeErrorMsg,
      addonBulkVoiceText,
      addonBulkDataText,
      addonBulkWirelessText,
      bulkCancelText,
      bulkUpgradeText,
      update,
      mdmText,
    },
    serviceNumbersPlanDetails,
    addOnCheckAll,
    addOnCheckboxVal,
    moveAddOnDetails,
    pageChangeHandler,
    currentPage,
    onChangeCheckBox,
    onAddOnChangeCheckBox,
    serviceNumbersWithFlag,
    iDOPlanDropDownValue,
    dataTopUpDropDownValue,
    voice2TextCheckboxVal,
    iPhoneMsgBankCheckboxVal,
    oneNumberCheckboxVal,
    monthPassCheckboxVal,
    acceleratorCheckboxVal,
    demandDataCheckboxVal,
    getPlanNameDetails,
    onSearchAddOnFieldChange,
    searchAddOnSelectedOption,
    searchText,
    searchTextChange,
    currentPlanList,
    onAddonBulkAction,
    addonWarningPopup,
    onAddonWarningPopupClose,
    addonBulkModal,
    onAddonBulkModalClose,
    bulkAddonIDDValue,
    bulkAddonDataTopupValue,
    bulkAddonVoice2TextCheckbox,
    bulkAddonMsgBankCheckbox,
    bulkAddonOneNumberCheckbox,
    bulkAddonMonthPassCheckbox,
    bulkAddonAcceleratorCheckbox,
    bulkAddonMdmCheckbox,
    bulkAddonDemandDataCheckbox,
    onAddonBulkIDDChangeDropDown,
    onAddonBulkDataTopupChangeDropDown,
    onAddonBulkCheckBox,
    onAddonBulkActionApply,
    onAddOnAllChangeCheckBox,
    isVoicePlan,
    isBrodbandPlan,
    isWirelessPlan,
    updatedSummaryTable,
    onUpdatedSummaryTableValue,
    mdmValue,
  } = props;

  const [pageSize, setPageSize] = useState(parseInt(paginationBaseNumber, 10));
  const pageSizeOptions = paginationNumbers.split(',');
  const [filterApplied, setFilterApplied] = useState(false);
  const [totalRecords, setTotalRecords] = useState(serviceNumbersPlanDetails.length);
  const numberOfPages = filterApplied ? Math.ceil(totalRecords / pageSize) : Math.ceil(serviceNumbersPlanDetails.length / pageSize);

  const iDDDropDownOptionsVal = iDOCallingPlans.options;
  const dataTopUpDropDownOptionsVal = dataTopUpPlans.options;
  const addOnSearchDropDownOptionsVal = addOnSearchFields.options;
  const [addOnSearchText, setAddOnSearchText] = useState('');

  const [filterOpen, setFilterOpen] = useState(false);
  const [filterClearAllStatus, setFilterClearAllStatus] = useState(false);
  const [filterSearchedResults, setFilterSearchedResults] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  React.useEffect(() => {
    if (updatedSummaryTable) {
      setFilterApplied(false);
      setFilterOpen(false);
      setFilterClearAllStatus(true);
    }
  });


  const onPageChange = (pageNumber) => {
    pageChangeHandler(pageNumber, 'add-on-table-section');
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setTimeout(() => {
      const lastTableRow = document.getElementById('addon-details-table').lastElementChild.lastElementChild;
      lastTableRow.scrollIntoView();
    }, 200);
  };

  const getNewIDDValue = (deviceKey, planName) => {
    const option = iDOCallingPlans.options.find(item => item.key === deviceKey);
    const defaultOption = iDOCallingPlans.options.find(item => item.key === 'na');
    if (option) {
      return option.value;
    }   
    return defaultOption.value;
  };

  const getNewDataValue = (deviceKey) => {
    const option = dataTopUpPlans.options.find(item => item.key === deviceKey);
    const defaultOption = dataTopUpPlans.options.find(item => item.key === 'na');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };

  const getSearchSelectionValue = (searchKey) => {
    const option = addOnSearchFields.options.find(item => item.key === searchKey);
    const defualtOption = addOnSearchFields.options.find(item => item.key === 'nosearch');
    if (option) {
      return option.value;
    }
    return defualtOption.value;
  };

  const getPlanName = serviceNumber => getPlanNameDetails(serviceNumber);
  const iDDDropDownOptions = prepareDropDownOptionsArry(iDDDropDownOptionsVal);
  const dataTopUpDropDownOptions = prepareDropDownOptionsArry(dataTopUpDropDownOptionsVal);
  const searchFieldsDropDownOptions = prepareDropDownOptionsArry(addOnSearchDropDownOptionsVal);

  const totalPlanSelected = () => {
    if (filterApplied && addOnSearchText.length > 0) {
      return Object.entries(addOnCheckboxVal)
        .filter(itm => filterSearchedResults.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    } else if (filterApplied) {
      return Object.entries(addOnCheckboxVal)
        .filter(itm => filteredData.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    }
    return Object.entries(addOnCheckboxVal)
      .filter(itm => serviceNumbersPlanDetails.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
        && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
  };

  const getDataRows = () => {
    if (filterApplied && addOnSearchText.length > 0) {
      return filterSearchedResults;
    } else if (filterApplied) {
      return filteredData;
    }
    return serviceNumbersPlanDetails;
  };

  const onSearchText = () => {
    if (filterApplied) {
      return addOnSearchText;
    }
    return searchText;
  };

  const onSearchTextChange = (event) => {
    const filterSearchText = event.target.value;
    setAddOnSearchText(filterSearchText);
    if (filterApplied) {
      let filterResults = [];
      if (searchAddOnSelectedOption === 'number') {
        filterResults = filteredData.filter(numbers => numbers.serviceNumber.includes(filterSearchText));
      } else if (searchAddOnSelectedOption === 'username') {
        filterResults = filteredData.filter(numbers => numbers.userName.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchAddOnSelectedOption === 'nosearch') {
        filterResults = filteredData;
        setAddOnSearchText('');
      }
      onPageChange(0);
      setTotalRecords(filterResults.length);
      setFilterSearchedResults(filterResults);
    } else {
      searchTextChange(event);
    }
  };

  const onSearchDropDownChange = (event) => {
    if (filterApplied) {
      setAddOnSearchText('');
      setFilterSearchedResults(filteredData);
      setTotalRecords(filteredData.length);
      onSearchAddOnFieldChange(event);
    } else {
      onSearchAddOnFieldChange(event);
    }
  };

  const applyFilterOnFullData = (filterObj) => {
    let filterResults = serviceNumbersPlanDetails;
    let suggestPlanResults = [];
    if (filterObj.recommendPlanSelectId.length > 0) {
      filterObj.recommendPlanSelectId.forEach((plan) => {
        const planResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].planName.toLowerCase() === plan.toLowerCase());
        suggestPlanResults = [...suggestPlanResults, ...planResults];
      });
      filterResults = [...suggestPlanResults];
    }
    onPageChange(0);
    setAddOnSearchText('');
    setFilterApplied(true);
    setFilteredData(filterResults);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
    setTotalRecords(filterResults.length);
  };

  const clearFilterApplied = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(true);
  };

  const cancelFilter = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
  };

  const setUpdatedSummaryTable = () => {
    if (updatedSummaryTable) {
      onUpdatedSummaryTableValue();
    }
    setFilterOpen(!filterOpen);
  };

  const bulkApplyOnSelectedItems = () => {
    if (addOnCheckAll) {
      if (filterApplied && addOnSearchText.length > 0) {
        const selectedNumbers = filterSearchedResults.filter(serviceItem => addOnCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        onAddonBulkActionApply(selectedNumbers);
      } else if (filterApplied) {
        const selectedNumbers = filteredData.filter(serviceItem => addOnCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        onAddonBulkActionApply(selectedNumbers);
      } else {
        const selectedNumbers = serviceNumbersPlanDetails.filter(serviceItem => addOnCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        onAddonBulkActionApply(selectedNumbers);
      }
    } else {
      const selectedNumbers = serviceNumbersPlanDetails.filter(serviceItem => addOnCheckboxVal[serviceItem.serviceNumber] === true)
        .map(serviceItem => serviceItem.serviceNumber);
      onAddonBulkActionApply(selectedNumbers);
    }
  };

  const checkBulkActionPossible = () => {
    if (filterApplied) {
      const selectedNumbers = filteredData.filter(serviceItem => addOnCheckboxVal[serviceItem.serviceNumber] === true)
        .map(serviceItem => serviceItem.serviceNumber);
      onAddonBulkAction(selectedNumbers);
    } else {
      const selectedNumbers = serviceNumbersPlanDetails.filter(serviceItem => addOnCheckboxVal[serviceItem.serviceNumber] === true)
        .map(serviceItem => serviceItem.serviceNumber);
      onAddonBulkAction(selectedNumbers);
    }
  };

  const onChangeAllCheckBox = (event) => {
    if (filterApplied) {
      onAddOnAllChangeCheckBox(event, filteredData);
    } else {
      onAddOnAllChangeCheckBox(event, serviceNumbersPlanDetails);
    }
  };

  const getTotalRecords = () => (filterApplied ? totalRecords : serviceNumbersPlanDetails.length);

  const rowData = dataTable => dataTable.slice(currentPage * pageSize, pageSize * (currentPage + 1)).map(service => (
    <tr key={`${service.serviceNumber}`}>
      <td className="sticky-col">
        {serviceNumbersWithFlag[service.serviceNumber].dataOnly === true &&
          <div className="table-item-text ri-flex-pill-width inline">
            <SvgIcon name="icon-authentication-hotspot" className="mobile-pill-icon" />
          </div>
        }
        {serviceNumbersWithFlag[service.serviceNumber].dataOnly === false &&
          <div className="table-item-text ri-flex-pill-width inline">
            <SvgIcon name="icon-mobiles-mobile" className="mobile-pill-icon" />
          </div>
        }
      </td>
      <td className="sticky-col1">
        {service.suggestedPlanName !== 'unaddressableServices' &&
          <div className="table-item-text ri-flex-service-width inline">
            <Checkbox
              id={`${service.serviceNumber}-addOnService`}
              onChange={onChangeCheckBox}
              checked={addOnCheckboxVal[service.serviceNumber]}
              label={formatPhoneNumber(service.serviceNumber)}
            />
            {service.fiveGInteraction === '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width inline">
                <SvgIcon name="icon-bill-5g" className="mobile-pill-icon" />
              </div>
            }
            {service.fiveGInteraction !== '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width-not-5g inline">
                <SvgIcon name="icon-system-circle-filled" className="mobile-pill-icon" />
              </div>
            }
          </div>
        }
      </td>
      <td><div className="table-item-text">{service.userName}</div></td>
      <td>
        <div className="table-item-text">
          {getPlanName(service.serviceNumber)}
        </div>
      </td>
      <td>
        <div className="new-device-selection table-item-text">
          {serviceNumbersWithFlag[service.serviceNumber].dataOnly === false &&
            serviceNumbersWithFlag[service.serviceNumber].planName !== 'mobileEnterpriseWireless' &&
            serviceNumbersWithFlag[service.serviceNumber].planName !== 'mobileEnterpriseWirelessEssential' &&
            serviceNumbersWithFlag[service.serviceNumber].planName !== 'mobileExecutive' &&
            serviceNumbersWithFlag[service.serviceNumber].planName !== 'mobileEpic' &&
            <Dropdown
              value={getNewIDDValue(iDOPlanDropDownValue[service.serviceNumber], serviceNumbersWithFlag[service.serviceNumber].planName)}
              dropdownId={`${service.serviceNumber}-ido-dropdown`}
              options={iDDDropDownOptions}
              onOptionClick={moveAddOnDetails}
              disabled={serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileExecutive'}
            />
          }
          {(serviceNumbersWithFlag[service.serviceNumber].dataOnly === true ||
            serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless' ||
            serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWirelessEssential') &&
            <div className="not-applicable-column">
              <span>{addOnNA}</span>
            </div>
          }
          {(serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEpic'
            || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileExecutive') &&
            <div className="not-applicable-column">
              <span>{getNewIDDValue(iDOPlanDropDownValue[service.serviceNumber], serviceNumbersWithFlag[service.serviceNumber].planName)}</span>
            </div>
          }

        </div>
      </td>
      <td>
        <div className="table-item-text">
          <Checkbox
            id={`${service.serviceNumber}-voice2Text`}
            onChange={onAddOnChangeCheckBox}
            checked={voice2TextCheckboxVal[service.serviceNumber]}
            disabled={serviceNumbersWithFlag[service.serviceNumber].dataOnly === true ||
              serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless'
            || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWirelessEssential'}
          />
        </div>
      </td>
      <td>
        <div className="table-item-text">
          <Checkbox
            id={`${service.serviceNumber}-iPhoneMessageBank`}
            onChange={onAddOnChangeCheckBox}
            checked={iPhoneMsgBankCheckboxVal[service.serviceNumber]}
            disabled={serviceNumbersWithFlag[service.serviceNumber].dataOnly === true ||
              serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless'
              || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWirelessEssential'}
          />
        </div>
      </td>
      <td>
        <div className="table-item-text">
          <Checkbox
            id={`${service.serviceNumber}-oneNumber`}
            onChange={onAddOnChangeCheckBox}
            checked={oneNumberCheckboxVal[service.serviceNumber]}
            disabled={serviceNumbersWithFlag[service.serviceNumber].dataOnly === true ||
              serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless'
              || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWirelessEssential'}
          />
        </div>
      </td>
      <td>
        <div className="table-item-text">
          <Checkbox
            id={`${service.serviceNumber}-monthPass`}
            onChange={onAddOnChangeCheckBox}
            checked={monthPassCheckboxVal[service.serviceNumber]}
            disabled={serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless'
                      || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileExecutive'
                      || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWirelessEssential'}
          />
        </div>
      </td>
      <td>
        <div className="table-item-text">
          <Checkbox
            id={`${service.serviceNumber}-accelerator`}
            onChange={onAddOnChangeCheckBox}
            checked={acceleratorCheckboxVal[service.serviceNumber]}
            disabled={serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless'
            || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWirelessEssential'}
          />
        </div>
      </td>
      <td className='d-none'>
        <div className="table-item-text">
          <Checkbox
            id={`${service.serviceNumber}-demandData`}
            onChange={onAddOnChangeCheckBox}
            checked={demandDataCheckboxVal[service.serviceNumber]}
            disabled={serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless'
            || serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWirelessEssential'}
          />
        </div>
      </td>
      <td className='d-none'>
        <div className="new-device-selection table-item-text">
          {serviceNumbersWithFlag[service.serviceNumber].planName === 'mobileEnterpriseWireless' &&
            <Dropdown
              value={getNewDataValue(dataTopUpDropDownValue[service.serviceNumber])}
              dropdownId={`${service.serviceNumber}-dataTopUp-dropdown`}
              options={dataTopUpDropDownOptions}
              onOptionClick={moveAddOnDetails}
            />
          }
          {(serviceNumbersWithFlag[service.serviceNumber].planName !== 'mobileEnterpriseWireless' 
            && serviceNumbersWithFlag[service.serviceNumber].planName !== 'mobileEnterpriseWirelessEssential') &&
            <span>{addOnNA}</span>
          }
        </div>
      </td>
      <td>
        <div className="table-item-text">
          <Checkbox
            id={`${service.serviceNumber}-mdm`}
            onChange={onAddOnChangeCheckBox}
            checked={mdmValue[service.serviceNumber]}
          />
        </div>
      </td>

    </tr>
  ));
  return (
    <div id="add-on-details-section-amp" className="add-on-details-section-amp">
      <div className="add-on-table">
        <div className="row table-nav">
          <div className="col-2 table-action items">
            {totalPlanSelected()} {itemSelectedText}
          </div>
          <div className="col-2 table-action">
            <Button
              variant="primary"
              size="medium"
              onClick={() => checkBulkActionPossible()}
              disabled={totalPlanSelected() === 0}
            >
              {bulkActionText}
            </Button>
          </div>
          <div className="col-3 search-field-option">
            {(filterOpen === false) &&
              <Dropdown
                value={getSearchSelectionValue(searchAddOnSelectedOption)}
                dropdownId="search-field-option"
                options={searchFieldsDropDownOptions}
                onOptionClick={onSearchDropDownChange}
                className="search-field-option-container"
              />
            }
          </div>
          <div className="col-2 search-field-option-text">
            {(filterOpen === false) &&
              <TextInput
                name="addOn-search-text"
                onChange={onSearchTextChange}
                placeholder={addOnSearchFields.placeholder}
                value={onSearchText()}
              />
            }
          </div>
          <div className="col-1 table-action">
            {filterApplied &&
              <Button
                variant="primary"
                onClick={() => clearFilterApplied()}
                size="medium"
              >
                {filterClearAll}
              </Button>
            }
          </div>
          <div className="col-1 offset-1 table-action filter-button">
            <SvgIcon name="icon-product-filter" className="icon-filter" />
            <Button
              variant="secondary"
              size="medium"
              state="app"
              className="filter-button"
              onClick={() => setUpdatedSummaryTable()}
            > {filterApplied ? filterEditTopLink : filterTopLink}</Button>
          </div>
          <div className="col-12">
            <AddOnFilters
              authorableContent={authorableContent}
              applyFilter={applyFilterOnFullData}
              cancelFilter={cancelFilter}
              filterOpen={filterOpen}
              filterApplied={filterApplied}
              currentPlanList={currentPlanList}
              filterClearAll={filterClearAllStatus}
            />
          </div>
        </div>
        <div id="add-on-table-section" className="add-on-table-section row">
          <div className="sticky-wrapper col-12">
            <div className="sticky-scroller">
              <table className="sticky-table" id="addon-details-table">
                <thead>
                  <tr>
                    <th className="sticky-col">&nbsp;</th>
                    <th className="sticky-col1">
                      <div className="table-title">
                        <Checkbox
                          id="all-addOnService"
                          onChange={e => onChangeAllCheckBox(e)}
                          checked={getTotalRecords() > 0 && getTotalRecords() === totalPlanSelected()}
                          label="Service Number"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {username}
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-large-width">
                        {serviceType}
                      </div>
                    </th>
                    <th><div className="table-title ri-flex-elarge-width">{intCallingIDO}</div></th>
                    <th><div className="table-title ri-flex-normal-width">{voice2Text}</div></th>
                    <th><div className="table-title ri-flex-small-width-120">{messageBankIphone}</div></th>
                    <th><div className="table-title ri-flex-normal-width">{oneNumber}</div></th>
                    <th><div className="table-title ri-flex-small-width-120">{iRMonthPass}</div></th>
                    <th>
                      <div className="table-title ri-flex-normal-width">
                        {accelerator}
                        <ToolTip
                          description={renderHTML(acceleratorToolTip)}
                          activeIconName="icon-system-info"
                          iconName="icon-system-info-default"
                          position="bottom"
                        />
                      </div>
                    </th>
                    <th className='d-none'><div className="table-title ri-flex-small-width-120">{demandData}</div></th>
                    <th className='d-none'><div className="table-title ri-flex-elarge-width">{dataTopUp}</div></th>
                    <th><div className="table-title ri-flex-small-width-120">{mdmText}</div></th>
                  </tr>
                </thead>
                <tbody>
                  {rowData(getDataRows())}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        pages={numberOfPages}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        totalRecordLength={filterApplied ? totalRecords : serviceNumbersPlanDetails.length}
        restorePageNumber={0}
        page={currentPage}
        canNext={(currentPage < numberOfPages - 1)}
        canPrevious={currentPage !== 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
      <Modal
        isOpen={addonWarningPopup}
        onShowModal={onAddonWarningPopupClose}
        modalType="alert-modal-warning"
        size="small"
        className="warning-modal"
      >
        <Modal.Header>
          <div className="row">
            <div className="col-12">
              <SvgIcon name="icon-system-alert-small" className="plan-type-error" />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              {planTypeErrorMsg}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {isVoicePlan &&
        <Modal
          isOpen={addonBulkModal}
          onShowModal={onAddonBulkModalClose}
          modalType="bulk-modal"
          size="xlarge"
          className="addon-bulk-modal voice"
        >
          <Modal.Header>
            <div className="row">
              <h1 className="col-12">{bulkActionText}</h1>
              <h6 className="col-12">{update} {totalPlanSelected()} {addonBulkVoiceText}</h6>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                <div className="bulk-form-field no-border no-bottom-padding">
                  <Dropdown
                    value={getNewIDDValue(bulkAddonIDDValue)}
                    dropdownId="bulk-ido-dropdown"
                    options={iDDDropDownOptions}
                    onOptionClick={onAddonBulkIDDChangeDropDown}
                    label={intCallingIDO}
                  />
                </div>
                <div className="bulk-form-field no-top-padding">
                  <Checkbox
                    id="bulk-voice2Text"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonVoice2TextCheckbox}
                    label={voice2Text}
                  />
                </div>
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-iPhoneMessageBank"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonMsgBankCheckbox}
                    label={messageBankIphone}
                  />
                </div>
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-oneNumber"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonOneNumberCheckbox}
                    label={oneNumber}
                  />
                </div>
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-monthPass"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonMonthPassCheckbox}
                    label={iRMonthPass}
                  />
                </div>
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-accelerator"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonAcceleratorCheckbox}
                    label={accelerator}
                  />
                </div>
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-mdm"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonMdmCheckbox}
                    label={mdmText}
                  />
                </div>

                <div className="bulk-form-field d-none">
                  <Checkbox
                    id="bulk-demandData"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonDemandDataCheckbox}
                    label={demandData}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-6 text-left">
                <Button
                  variant="secondary"
                  size="xSmall"
                  onClick={onAddonBulkModalClose}
                  className="bulk-action-cancel"
                >{bulkCancelText}</Button>
              </div>
              <div className="col-6 text-right">
                <Button
                  variant="super"
                  size="medium"
                  state="app"
                  onClick={() => bulkApplyOnSelectedItems()}
                >{bulkUpgradeText}</Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      }
      {isBrodbandPlan &&
        <Modal
          isOpen={addonBulkModal}
          onShowModal={onAddonBulkModalClose}
          modalType="bulk-modal"
          size="xlarge"
          className="addon-bulk-modal data"
        >
          <Modal.Header>
            <div className="row">
              <h1 className="col-12">{bulkActionText}</h1>
              <h6 className="col-12">{update} {totalPlanSelected()} {addonBulkDataText}</h6>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-monthPass"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonMonthPassCheckbox}
                    label={iRMonthPass}
                  />
                </div>
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-accelerator"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonAcceleratorCheckbox}
                    label={accelerator}
                  />
                </div>
                <div className="bulk-form-field">
                  <Checkbox
                    id="bulk-mdm"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonMdmCheckbox}
                    label={mdmText}
                  />
                </div>
                <div className="bulk-form-field d-none">
                  <Checkbox
                    id="bulk-demandData"
                    onChange={onAddonBulkCheckBox}
                    checked={bulkAddonDemandDataCheckbox}
                    label={demandData}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-6 text-left">
                <Button
                  variant="secondary"
                  size="xSmall"
                  onClick={onAddonBulkModalClose}
                  className="bulk-action-cancel"
                >{bulkCancelText}</Button>
              </div>
              <div className="col-6 text-right">
                <Button
                  variant="super"
                  size="medium"
                  state="app"
                  onClick={() => bulkApplyOnSelectedItems()}
                >{bulkUpgradeText}</Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      }
      {isWirelessPlan &&
        <Modal
          isOpen={addonBulkModal}
          onShowModal={onAddonBulkModalClose}
          modalType="bulk-modal"
          size="xlarge"
          className="addon-bulk-modal wireless"
        >
          <Modal.Header>
            <div className="row">
              <h1 className="col-12">{bulkActionText}</h1>
              <h6 className="col-12">{update} {totalPlanSelected()} {addonBulkWirelessText}</h6>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                <div className="bulk-form-field no-border no-bottom-padding">
                  <Dropdown
                    value={getNewDataValue(bulkAddonDataTopupValue)}
                    dropdownId="bulk-data-topup-dropdown"
                    options={dataTopUpDropDownOptions}
                    onOptionClick={onAddonBulkDataTopupChangeDropDown}
                    label={dataTopUp}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-6 text-left">
                <Button
                  variant="secondary"
                  size="xSmall"
                  onClick={onAddonBulkModalClose}
                  className="bulk-action-cancel"
                >{bulkCancelText}</Button>
              </div>
              <div className="col-6 text-right">
                <Button
                  variant="super"
                  size="medium"
                  state="app"
                  onClick={() => bulkApplyOnSelectedItems()}
                >{bulkUpgradeText}</Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      }
    </div>
  );
};

export default AddOnTable;
